import { PageProps } from "../types/page";

export const ExitButton: React.FC<PageProps> = ({ onPageExit }) => {
  return (
    <button className="x-button" onClick={(e) => onPageExit(e)}>
      X
    </button>
  );
};
